module.exports = __webpack_public_path__ + "static/media/xm-logo.cf464330.png";